export const WRITE_SCOPED_TOOLS = new Set<string>([
  'pause_campaign',
  'launch_campaign',
  'create_brand',
  'update_brand',
  'delete_brand',
  'create_audience',
  'apply_supply_list_with_discovery',
  'send_email',
  'write_file_output',
])
